const baseUrl = process.env.VUE_APP_BASE_API || '';

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

export function resolveImageUrl(src) {
  if (!src) return '';
  const url = String(src).split(',')[0].trim();
  if (!url) return '';
  if (isExternal(url)) return url;
  return baseUrl + url;
}
